/* Top Racing Point - Ricerca per passo (23/10/2026)
   Su "colonnette-ruota" e "bulloni-dadi-ruota": tendine Passo (filettatura) > Lunghezza > Sede,
   costruite dai tag dei prodotti della pagina: "filettatura m12x1.5", "lunghezza 82", "sede conica".
   24/10/2026: prima Marca > Modello (elenco di trp-dist-auto.js): mostra il passo dell'auto e lo sceglie nella tendina Passo,
   poi Lunghezza / Sede. L'auto scelta resta in memoria (sessionStorage) quando si aprono i risultati.
   24/10/2026 (Bulloneria Ruote): anche su dadi-ruota, bulloni-ruota, antifurto-ruote, colonnette-a-vite; sulle colonnette
   avviso per le marche che di serie hanno prigionieri a piantaggio e dadi (elenco PRIGIONIERI).
   Il pulsante apre la collezione filtrata per tag: /collections/colonnette-ruota/filettatura-m12x1-5+lunghezza-82 */
(function(){
  var ORD=['th','l','sd'];
  function ready(fn){ if(document.readyState!=='loading'){ fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }
  function handleize(t){ return String(t).toLowerCase().normalize('NFD').split('').filter(function(ch){ var k=ch.charCodeAt(0); return k<768 || k>879; }).join('').replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,''); }
  function esc(t){ return String(t).replace(/[&<>"]/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function tagDi(k,v){ return k==='th' ? 'filettatura '+v : (k==='l' ? 'lunghezza '+v : 'sede '+v); }
  function etichetta(k,v){
    if(k==='th') return /^m\d/.test(v) ? 'M'+v.slice(1) : v.toUpperCase().replace('UNF','UNF');
    if(k==='l') return v+' mm';
    return v.charAt(0).toUpperCase()+v.slice(1);
  }
  function ordina(k){ return function(a,b){
    if(k==='th'){ var x=a.match(/m(\d+)x([\d.]+)/), y=b.match(/m(\d+)x([\d.]+)/); if(x && y) return (+x[1]-y[1]) || (+x[2]-y[2]); return x ? -1 : (y ? 1 : a.localeCompare(b)); }
    if(k==='l') return parseFloat(a)-parseFloat(b);
    return a.localeCompare(b);
  }; }
  function leggi(righe){
    return righe.map(function(r){
      var m={th:{},l:{},sd:{}};
      (r[1]||[]).forEach(function(tag){
        var l=String(tag).toLowerCase().trim(), x;
        if((x=l.match(/^filettatura (.+)$/))) m.th[x[1]]=1;
        else if((x=l.match(/^lunghezza (\d+(?:\.\d+)?)$/))) m.l[x[1]]=1;
        else if((x=l.match(/^sede (conica|sferica|piana)$/))) m.sd[x[1]]=1;
      });
      return m;
    });
  }
  function combacia(m,s){ for(var k in s){ if(s[k] && !m[k][s[k]]) return false; } return true; }
  function conta(d,s){ var n=0; d.forEach(function(m){ if(combacia(m,s)) n++; }); return n; }
  function valori(d,k,altre){
    var c={};
    d.forEach(function(m){ if(!combacia(m,altre)) return; for(var v in m[k]){ c[v]=(c[v]||0)+1; } });
    return Object.keys(c).sort(ordina(k)).map(function(v){ return [v,c[v]]; });
  }
  function opzione(v,l){ var o=document.createElement('option'); o.value=v; o.textContent=l; return o; }
  function carica(base,fatto){
    var tutti=[];
    function pagina(n){ return fetch(base+'?view=trpauto&page='+n,{credentials:'same-origin'}).then(function(r){ return r.text(); }).then(function(t){ return JSON.parse(t); }); }
    pagina(1).then(function(j){
      tutti=tutti.concat(j.p||[]);
      var resto=[]; for(var i=2;i<=(j.pagine||1);i++){ resto.push(pagina(i)); }
      return Promise.all(resto);
    }).then(function(a){ a.forEach(function(j){ tutti=tutti.concat(j.p||[]); }); fatto(leggi(tutti)); }).catch(function(){ fatto(null); });
  }

  ready(function(){
    var root=document.querySelector('[data-trp-passo]'); if(!root) return;
    var handle=root.getAttribute('data-handle'), base='/collections/'+handle;
    var nome=root.getAttribute('data-nome')||'prodotti';
    function sel(k){ return root.querySelector('[data-trp-sel="'+k+'"]'); }
    function campo(k){ return root.querySelector('[data-trp-campo="'+k+'"]'); }
    var riepilogo=root.querySelector('[data-trp-riepilogo]'), btn=root.querySelector('[data-trp-vai]');
    var selMarca=sel('marca'), selMod=sel('modello'), info=root.querySelector('[data-trp-auto-info]');
    var AUTO=window.TRP_DIST_AUTO||{};
    var tipo=root.getAttribute('data-tipo')||'', urlPiantaggio=root.getAttribute('data-piantaggio-url')||'', urlDadi=root.getAttribute('data-dadi-url')||'';
    // marche che di serie hanno quasi sempre prigionieri (a piantaggio) e dadi invece dei bulloni
    var PRIGIONIERI=['honda','nissan','infiniti','toyota','lexus','mazda','mitsubishi','subaru','suzuki','daihatsu','hyundai','kia','proton','jeep','dodge','chrysler','chevrolet','cadillac','gmc','buick','pontiac','lincoln','tesla'];

    carica(base,function(dati){
      if(!dati){ root.querySelector('[data-trp-errore]').hidden=false; return; }
      function scelte(){ var s={}; ORD.forEach(function(k){ var e=sel(k); if(e && e.value) s[k]=e.value; }); return s; }
      function aggiorna(){
        var s=scelte();
        ORD.forEach(function(k){
          var e=sel(k); if(!e) return;
          var altre={}; for(var x in s){ if(x!==k) altre[x]=s[x]; }
          var lista=valori(dati,k,altre), prima=e.value;
          e.innerHTML=''; e.appendChild(opzione('', k==='th' ? 'Scegli il passo' : (k==='l' ? 'Tutte le lunghezze' : 'Tutte')));
          lista.forEach(function(v){ e.appendChild(opzione(v[0], etichetta(k,v[0])+' ('+v[1]+')')); });
          if(prima && lista.some(function(v){ return v[0]===prima; })) e.value=prima;
          e.disabled=!lista.length;
          var c=campo(k); if(c && k!=='th') c.hidden=!valori(dati,k,{}).length;
        });
        s=scelte();
        var n=conta(dati,s), qualcosa=Object.keys(s).length>0;
        btn.disabled=!qualcosa || !n;
        btn.querySelector('span').textContent=qualcosa ? (n ? 'Mostra '+n+(n===1?' prodotto':' '+nome) : 'Nessun prodotto') : 'Mostra '+nome;
      }
      ORD.forEach(function(k){ var e=sel(k); if(e) e.addEventListener('change',aggiorna); });
      btn.addEventListener('click',function(){
        var s=scelte(), pezzi=ORD.filter(function(k){ return s[k]; }).map(function(k){ return handleize(tagDi(k,s[k])); });
        window.location.assign(base+(pezzi.length ? '/'+pezzi.join('+') : ''));
      });

      // Prima l'auto: Marca > Modello mostrano il passo e lo scelgono nella tendina sotto
      var CHIAVE='trpPassoAuto', daAuto=false;
      function salva(v){ try{ if(v){ sessionStorage.setItem(CHIAVE,JSON.stringify(v)); } else { sessionStorage.removeItem(CHIAVE); } }catch(e){} }
      function leggiSalvato(){ try{ return JSON.parse(sessionStorage.getItem(CHIAVE)||'null'); }catch(e){ return null; } }
      function evidenzia(){ var c=campo('th'); if(!c) return; c.classList.remove('trp-passo--evid'); void c.offsetWidth; c.classList.add('trp-passo--evid'); }
      function riempiModelli(){
        selMod.innerHTML=''; selMod.appendChild(opzione('', selMarca.value ? 'Scegli il modello' : 'Prima la marca'));
        (AUTO[selMarca.value]||[]).forEach(function(x){ selMod.appendChild(opzione(x[0],x[0])); });
        selMod.disabled=!selMarca.value;
      }
      function mostraAuto(scegli){
        var r=null; (AUTO[selMarca.value]||[]).forEach(function(x){ if(x[0]===selMod.value) r=x; });
        if(!r){ info.hidden=true; return; }
        var fili={}; r[1].forEach(function(f){ (f[2]||'').split('/').forEach(function(t){ if(t) fili[t.toLowerCase()]=1; }); });
        var lista=Object.keys(fili), auto=esc(selMarca.value+' '+selMod.value);
        if(!lista.length){
          info.innerHTML='Per la <strong>'+auto+'</strong> il passo non è ancora nel nostro elenco: lo trovi sul libretto di uso e manutenzione, oppure scrivici marca, modello e anno a <a href="mailto:info@topracingpoint.com">info@topracingpoint.com</a>.';
          if(scegli && daAuto){ sel('th').value=''; daAuto=false; aggiorna(); }
        } else {
          var disp=valori(dati,'th',{}).map(function(v){ return v[0]; });
          var ok=lista.filter(function(t){ return disp.indexOf(t)>-1; });
          var testo='La tua <strong>'+auto+'</strong> ha passo <strong>'+lista.map(function(t){ return esc(etichetta('th',t)); }).join(' o ')+'</strong>.';
          if(tipo==='colonnette' && PRIGIONIERI.indexOf(selMarca.value.toLowerCase())>-1 && urlPiantaggio){
            testo+=' <span class="trp-passo__avviso">Attenzione: le '+esc(selMarca.value)+' di solito hanno di serie <strong>prigionieri fissi e dadi</strong>, non bulloni: in quel caso queste colonnette a vite non servono. Guarda i <a href="'+esc(urlPiantaggio)+'">prigionieri a piantaggio</a> per la tua auto o i <a href="'+esc(urlDadi)+'">dadi ruota</a>.</span>';
          }
          if(!ok.length) testo+=' Al momento non abbiamo '+esc(nome)+' con questo passo: scrivici e te le troviamo.';
          else if(ok.length===1){ var poi=(campo('l')&&!campo('l').hidden) ? 'la lunghezza' : ((campo('sd')&&!campo('sd').hidden) ? 'la sede' : ''); testo+=' L\'abbiamo già scelto nella tendina Passo: '+(poi ? 'ora scegli '+poi+' e premi il pulsante.' : 'ora premi il pulsante.'); }
          else testo+=' Dipende dalla versione: scegli il passo giusto nella tendina.';
          testo+=' <span class="trp-passo__nota">Nel dubbio controlla sul libretto o scrivici.</span>';
          info.innerHTML=testo;
          if(scegli){
            if(ok.length===1){ sel('th').value=ok[0]; daAuto=true; aggiorna(); evidenzia(); }
            else if(daAuto){ sel('th').value=''; daAuto=false; aggiorna(); }
          }
        }
        info.hidden=false;
      }
      if(selMarca){
        selMarca.innerHTML=''; selMarca.appendChild(opzione('','Scegli la marca'));
        Object.keys(AUTO).forEach(function(m){ selMarca.appendChild(opzione(m,m)); });
        selMarca.disabled=false;
        selMarca.addEventListener('change',function(){
          riempiModelli(); info.hidden=true; salva(null);
          if(daAuto){ sel('th').value=''; daAuto=false; aggiorna(); }
        });
        selMod.addEventListener('change',function(){
          salva(selMod.value ? {marca:selMarca.value, modello:selMod.value} : null);
          mostraAuto(true);
        });
        sel('th').addEventListener('change',function(){ daAuto=false; });
        var az=root.querySelector('[data-trp-azzera]'); if(az) az.addEventListener('click',function(){ salva(null); });
      }

      // Lettura dell'indirizzo (pagina dei risultati)
      var dopo=(window.location.pathname.replace(/\/$/,'').split('/collections/')[1]||'').split('/');
      var pezziUrl=dopo[1] ? dopo[1].split('+') : [];
      var attuali={};
      ORD.forEach(function(k){ valori(dati,k,{}).forEach(function(x){ if(pezziUrl.indexOf(handleize(tagDi(k,x[0])))>-1) attuali[k]=x[0]; }); });
      aggiorna();
      ORD.forEach(function(k){ var e=sel(k); if(e && attuali[k]) e.value=attuali[k]; });
      aggiorna();
      // numeri dei passi sui campi visibili
      var n0=0; [].forEach.call(root.querySelectorAll('.trp-passo__grid .trp-vehicle-finder__field'),function(c){ if(c.hidden) return; var b=c.querySelector('.trp-cerchi__n'); n0++; if(b) b.textContent=n0; }); var gr=root.querySelector('.trp-passo__grid'); if(gr) gr.style.setProperty('--trp-n',n0);
      // auto scelta prima di aprire i risultati
      var salvata=leggiSalvato();
      if(selMarca && salvata && AUTO[salvata.marca]){
        selMarca.value=salvata.marca; riempiModelli();
        if((AUTO[salvata.marca]||[]).some(function(x){ return x[0]===salvata.modello; })){ selMod.value=salvata.modello; mostraAuto(!attuali.th); }
      }
      if(Object.keys(attuali).length){
        var parti=[], nomi={th:'Passo',l:'Lunghezza',sd:'Sede'};
        ORD.forEach(function(k){ if(attuali[k]) parti.push(nomi[k]+' <strong>'+esc(etichetta(k,attuali[k]))+'</strong>'); });
        var n=conta(dati,attuali);
        riepilogo.innerHTML='Stai vedendo: '+parti.join(' &middot; ')+' &mdash; <strong>'+n+(n===1?' prodotto':' prodotti')+'</strong><a href="'+base+'">Azzera ricerca</a>';
        riepilogo.hidden=false;
      }
    });
  });

  if(typeof module!=='undefined') module.exports={leggi:leggi, valori:valori, conta:conta, handleize:handleize, tagDi:tagDi, etichetta:etichetta};
})();
